import { pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { T } from "./youtube-video-editor.i18n";

type YoutubeVideoEditorProps = {
  url: string;
  flowLanguage: string;
  onChange: (url: string) => void;
};

export function YoutubeVideoEditor({ url, flowLanguage, onChange }: YoutubeVideoEditorProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-2">
      <Label htmlFor="youtube-url">
        {t.youtubeUrl} <span className="text-destructive">*</span>
      </Label>
      <Input
        id="youtube-url"
        value={url}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t.placeholder}
        required
      />
      <p className="text-xs text-muted-foreground">{t.helpText}</p>
    </div>
  );
}
